import { gql } from '@apollo/client';

const GET_WAREHOUSE_RELEASES = gql`
  query GetWarehouseReleases($orderBy: String, $statuses: [String]) {
    me {
      id
      warehouseReleases(orderBy: $orderBy, statuses: $statuses) {
        edges {
          node {
            id
            releaseId
            status
            createdDate
            modifiedDate
            remarks
            receiver
            sumOfModelQuantities
            allComponentVariantsReady
            warehouseReleaseModel {
              ready
              modelSpecification {
                id
                itemCode
              }
            }
          }
        }
      }
    }
  }
`;

export default GET_WAREHOUSE_RELEASES;
